// https://gist.github.com/wicharek/01abfd68b99e8206229b90dd0bc917cf
export function getAllClassMethods(obj) {
    let keys = [];
    let topObject = obj;

    const onlyOriginalMethods = (p, i, arr) =>
        typeof topObject[p] === "function" && // only the methods
        p !== "constructor" && // not the constructor
        (i === 0 || p !== arr[i - 1]) && // not overriding in this prototype
        keys.indexOf(p) === -1; // not overridden in a child

    do {
        const l = Object.getOwnPropertyNames(obj).filter(onlyOriginalMethods);
        keys = keys.concat(l);

        // walk-up the prototype chain
        obj = Object.getPrototypeOf(obj);
    } while (
        // not the the Object prototype methods (hasOwnProperty, etc...)
        obj &&
        Object.getPrototypeOf(obj)
    );

    return keys;
}

import { leftJoin } from "@/v2/utils/array.js";
// Gets properties that are defined only in the current class and not by any parent classes
export function getCurrentClassProperties(obj) {
    let keys = [];
    let topObject = obj;

    const onlyCurrentProperties = (p, i, arr) =>
        typeof topObject[p] !== "function" && // only the properties
        p !== "constructor" && // not the constructor
        (i === 0 || p !== arr[i - 1]) && // not overriding in this prototype
        keys.indexOf(p) === -1; // not overridden in a child

    const l = Object.getOwnPropertyNames(obj).filter(onlyCurrentProperties);

    keys = keys.concat(l);

    // get parent
    obj = Object.getPrototypeOf(obj);

    // is already the parent
    if (!(obj && Object.getPrototypeOf(obj))) {
        return keys;
    }

    // Intersect current keys with parent keys
    l = Object.getOwnPropertyNames(obj).filter(onlyOriginalMethods);

    keys = leftJoin(keys, l);

    return keys;
}

export function clearObject(obj) {
    for (let i in obj) {
        if (obj.hasOwnProperty(i)) {
            delete obj[i];
        }
    }
}

export function objectFilter(obj, predicate) {
    return Object.fromEntries(Object.entries(obj).filter(predicate));
}

export function firstKey(obj) {
    for (const key in obj) {
        return key;
    }
}

export function first(obj) {
    for (const key in obj) {
        return obj[key];
    }
}

export function getOrDefault(obj, key, defaultValue = null) {
    return obj?.[key] ?? defaultValue;
}

export function isEqualObj(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (obj1[key] !== obj2[key]) {
            return false;
        }
    }

    return true;
}
